import { useRef } from 'react';

import { createModuleLogger } from '#apps/client-web/app/services/logger';

export const useLogger = (moduleName: string) => {
  const loggerRef = useRef(createModuleLogger(moduleName));
  return loggerRef.current;
};
